import { createRouter, createWebHistory } from 'vue-router'
import OverviewView from '../views/Overview.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home.vue')
    },
    {
      path: '/overview',
      name: 'overview',
      meta: { requiresRole: ['supusr'] },
      component: OverviewView
    },
    {
      path: '/cms/:node?',
      name: 'cms',
      meta: { requiresPermission: ['CMSMGR'] },
      component: () => import('../views/CMS/CMS.vue')
    },
    // {
    //   path: '/mapper',
    //   name: 'mapper',
    //   meta: { requiresRole: ['supusr'] },
    //   component: () => import('../views/Mapper/Mapper.vue')
    // },
    {
      path: '/mappings/:section?',
      name: 'mappings',
      meta: { requiresRole: ['supusr'] },
      component: () => import('../views/Mappings/Mappings.vue')
    },
    {
      path: '/automapper/:dealershipId?',
      name: 'automapper',
      meta: { requiresRole: ['supusr'] },
      component: () => import('../views/Automapper/Automapper.vue')
    },
    {
      path: '/features',
      name: 'features',
      component: () => import('../views/FeatureFlags/FeatureFlags.vue')
    },
    {
      path: '/dealerships',
      meta: { requiresRole: ['supusr'] },
      children: [
        {
          path: '',
          name: 'dealerships',
          meta: { requiresRole: ['supusr'] },
          component: () => import('../views/Dealerships/Dealerships.vue')
        },
        {
          path: 'edit/:id',
          name: 'editDealership',
          meta: { requiresRole: ['supusr'] },
          component: () => import('../views/Dealerships/EditDealership.vue')
        },
        {
          path: 'new',
          name: 'newDealership',
          meta: { requiresRole: ['supusr'] },
          component: () => import('../views/Dealerships/NewDealership.vue')
        }
      ]
    },
    {
      path: '/targetsites/:id?',
      name: 'targetsites',
      component: () => import('../views/TargetSites/TargetSites.vue'),
      meta: { requiresRole: ['supusr'] }
    },
    {
      path: '/goaltracker',
      name: 'goaltracker',
      component: () => import('../views/GoalTracker/GoalTracker.vue'),
      meta: { requiresRole: ['supusr'] }
    }
  ]
})

async function hasAccess(meta) {
  if (meta.requiresRole == null && meta.requiresPermission == null) return true
  const user = await window.seezSdk.getCurrentUser()
  if (user == null) return false
  if (user.roles.some(r => r.rolecode === 'supusr')) return true
  if (meta.requiresRole != null && user.roles.some(r => meta.requiresRole.includes(r.rolecode))) return true
  if (meta.requiresPermission != null && Object.keys(user.p).some(p => meta.requiresPermission.includes(p))) return true
  return false
}

router.beforeResolve(async (to, _, next) => {
  if (hasAccess(to.meta)) next()
  else {
    await window.seezSdk.showLogin()
    if (hasAccess(to.meta)) next()
    else next('/')
  }
})

export default router
